"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fieldset = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var atoms_1 = require("../../atoms");
var styles_1 = require("./styles");
exports.Fieldset = react_1.default.memo(function (_a) {
    var title = _a.title, description = _a.description, _b = _a.divider, divider = _b === void 0 ? true : _b, children = _a.children, _c = _a.multilineBox, multilineBox = _c === void 0 ? false : _c, _d = _a.thinHeader, thinHeader = _d === void 0 ? false : _d, _e = _a.color, color = _e === void 0 ? "blue" : _e, rest = __rest(_a, ["title", "description", "divider", "children", "multilineBox", "thinHeader", "color"]);
    var classes = (0, styles_1.useStyles)({ multilineBox: multilineBox, thinHeader: thinHeader, color: color });
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ border: "none", marginY: 2, component: "fieldset", className: classes.container }, rest, { children: [(0, jsx_runtime_1.jsx)(atoms_1.Text, __assign({ color: "primary", type: "text", weight: "bold", component: "legend", marginBottom: 2, className: classes.header }, { children: title })), description ? ((0, jsx_runtime_1.jsx)(atoms_1.Text, __assign({ size: "small", lineHeight: "16px", component: "p", marginBottom: "20px" }, { children: description }))) : undefined, (0, jsx_runtime_1.jsx)(core_1.Box, __assign({ marginBottom: 3, className: classes.content }, { children: children })), divider ? (0, jsx_runtime_1.jsx)(core_1.Divider, {}) : undefined] })));
});
